// Golf 3 (0034_kaart_agenda; docs/DESIGN.md §8.KA): plaatsen zoeken bij "Waar", de reistijd en
// Agenda koppelen. Handgeschreven zoals activity.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/places.ts en calendarFeeds.ts); openapi.contract.test.ts bewaakt
// elke aanroep. Alleen de server praat met Google; de browser stuurt de getypte tekst naar ons.
const id = (value) => encodeURIComponent(value);
const secretOf = (r) => ({
    link: r.feed,
    url: r.url,
    webcal_url: r.webcal_url,
    seq: r.seq,
});
export function createMapsClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const patch = (path, body) => t.request('PATCH', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const del = (path, body) => t.request('DELETE', path, body);
    return {
        places: {
            /** Zoeken tijdens typen (vanaf 3 tekens, na 300 ms stilte; één sessie per invulbeurt). */
            autocomplete: (input, sessionToken) => post('/v1/app/places/autocomplete', {
                input,
                session_token: sessionToken,
            }),
            details: (placeId, sessionToken) => post(`/v1/app/places/${id(placeId)}`, sessionToken ? { session_token: sessionToken } : {}),
        },
        eventPlace: {
            get: (seriesId) => get(`/v1/app/events/${id(seriesId)}/place`),
            set: (seriesId, input) => put(`/v1/app/events/${id(seriesId)}/place`, input),
        },
        travel: {
            settings: () => get('/v1/app/travel/settings'),
            setSettings: (input) => put('/v1/app/travel/settings', input),
        },
        calendarLinks: {
            list: () => get('/v1/app/calendar-links'),
            create: async (input) => secretOf(await post('/v1/app/calendar-links', input)),
            update: async (linkId, input) => {
                const r = await patch(`/v1/app/calendar-links/${id(linkId)}`, input);
                return { link: r.feed, seq: r.seq };
            },
            renew: async (linkId, ifVersion) => secretOf(await post(`/v1/app/calendar-links/${id(linkId)}/renew`, ifVersion === undefined ? {} : { if_version: ifVersion })),
            remove: (linkId, ifVersion) => del(`/v1/app/calendar-links/${id(linkId)}`, ifVersion === undefined ? undefined : { if_version: ifVersion }),
        },
    };
}
//# sourceMappingURL=maps.js.map